import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const TimelineInsert = createAsyncThunk(
    'TimelineInsert',
    async (data) => {
        let url = baseUrl+'TimelineInsert';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

 
  export const TimelineGet = createAsyncThunk(
    'TimelineGet',
    async (data) => {
        let url = baseUrl+'TimelineGet';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status == "success"){
            return Promise.resolve(response)
        } else if(response.status == "error") {
          return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const TimelineLike = createAsyncThunk(
    'TimelineLike',
    async (data) => {
        let url = baseUrl+'TimelineLike';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const CompanyTimeline = createAsyncThunk(
    'CompanyTimeline',
    async (data) => {
        let url = baseUrl+'companyTimeline';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const CommentInsert = createAsyncThunk(
    'CommentInsert',
    async (data) => {
        let url = baseUrl+'commentInsert';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const GetComment = createAsyncThunk(
    'GetComment',
    async (data) => {
        let url = baseUrl+'getComment';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status == "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const DeletePost = createAsyncThunk(
    'DeletePost',
    async (data) => {
        let url = baseUrl+'TimelineDelete';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status == "success"){
            return Promise.resolve(response)
        } else {
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
  